const testimonials = [
  {
    name: "Jessica M.",
    location: "Rome, GA",
    rating: 5,
    text: "I had a medical conference in London in 8 days and my passport was expired. Fast Passport Center was incredible. I started online from my home in Rome, shipped from the UPS Store on Shorter Avenue, and had my passport in hand in 6 days. I couldn't believe it.",
    service: "Emergency Passport",
  },
  {
    name: "Brian K.",
    location: "Cedartown, GA",
    rating: 5,
    text: "We booked a family cruise to the Caribbean and realized my son needed a passport. I had no idea both parents had to be there. Fast Passport Center sent us a checklist, told us exactly which clerk to visit in Rome, and handled the rest. Got it in 11 days. Lifesaver.",
    service: "Child Passport",
  },
  {
    name: "Amanda T.",
    location: "Calhoun, GA",
    rating: 5,
    text: "My passport was damaged in a flood two weeks before a business trip to Toronto. I was devastated. Fast Passport Center walked me through the replacement process, reviewed my documents, and got my new passport processed in 8 days. I shipped from Calhoun overnight.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function RomeTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Rome Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Rome, Cedartown, Calhoun, and northwest Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}